import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';

import type { EventApi } from './EventApi';
import { lunaEventApi } from './luna';

const EventApiContext = createContext<EventApi>(lunaEventApi);

interface EventApiProviderProps {
  api?: EventApi;
  children: ReactNode;
}

function EventApiProvider({ api = lunaEventApi, children }: EventApiProviderProps): JSX.Element {
  return (
    <EventApiContext.Provider value={api}>
      {children}
    </EventApiContext.Provider>
  );
}

function useEventApi(): EventApi {
  return useContext(EventApiContext);
}

export { EventApiProvider, useEventApi };
